(function ($){
    $(document).on('click', '.js-video-play', function (e) {
        e.preventDefault();

        const $wrap = $(this).closest('.js-video-wrapper');
        const $videoEl = $wrap.find('video');
        const video = $videoEl.get(0);

        $(this).addClass('js-video-ready');

        $videoEl.attr('controls', true).attr('playsinline', true);

        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
                video.muted = true;
                video.play();
            });
        }
    });
}(jQuery));
